import { render, staticRenderFns } from "./GalleryDialog.vue?vue&type=template&id=07c70c24&scoped=true&"
import script from "./GalleryDialog.vue?vue&type=script&lang=js&"
export * from "./GalleryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c70c24",
  null
  
)

export default component.exports